import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import Facade from '@/Facade'
import { WinningUtil } from '@/managers/winning/WinningUtil'

export class StopSpinState extends BaseState {
    private _reelsCount: number

    public begin() {
        GameSignals.reelStopped.connect(this.onReelStopped)
        GameSignals.stopButtonClicked.connect(this.onStopButtonClicked)

        this._model.bigWinLevel = WinningUtil.getBigWinLevel(this._model.spinData.base_win_currency, this._model.currentBaseBet)
        this._reelsCount = 0

        GameSignals.stopSpin.emit(this._model.spinData)
    }

    private onReelStopped = () => {
        this._reelsCount++
        if (this._reelsCount === Facade.reelsConfig.TOTAL_REELS) {
            this.end()
        }
    }

    private onStopButtonClicked = () => {
        if (Facade.currentState !== GameStatesEnum.STOP_SPIN_STATE) {
            return
        }

        GameSignals.immediatelyStop.emit()
    }

    public end = () => {
        this._model.spinState.isWinSkipped = false
        this._stateMachine.setState(GameStatesEnum.CASCADE_STATE)
    }

    public cleanUp() {
        GameSignals.reelStopped.disconnect(this.onReelStopped)
        GameSignals.stopButtonClicked.disconnect(this.onStopButtonClicked)
    }
}
